<template lang="pug">
    #forgot.columns.is-centered
        .column.is-half-desktop
            form.hero#forgot-form(@submit.prevent="forgotHandler")
                .field
                    label.label.is-unselectable(for="login") E-mail
                    .control
                        input.input#login(name="login" type="text" v-model="email" placeholder="E-mail")
                .field
                    .level.is-mobile
                        .level-left
                            button.button.is-primary(type="submit" :class="{ 'is-loading': inProcess }") Send
                        .level-right
                            router-link(to="/reset") Reset credentials
</template>

<script>
export default {
  name: "Forgot",
  data() {
    return {
      email: "",
      inProcess: false
    };
  },
  methods: {
    forgotHandler() {
      alert("Submit");
    }
  }
};
</script>

<style scoped></style>
